const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "https://api.home-helper.com";

export async function generateProjectReadinessSummary(payload) {
  const response = await fetch(
    `${API_BASE_URL}/api/tools/project-readiness-summary`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }
  );

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(
      data.error || "Unable to generate project readiness summary right now."
    );

    error.details = data.details || null;
    throw error;
  }

  return data;
}

export default {
  generateProjectReadinessSummary,
};